module.exports = __webpack_public_path__ + "static/media/ic_bell.b361e570.svg";